import React, { useState, useEffect, useCallback } from "react";
import VideoBox from "./VideoBox";
import { FaStar, FaRegStar } from "react-icons/fa";
import { pickProximityPair, updateEloRatings } from "./services";
import { Link } from "./usePath";

const MEDALS = ["🥇", "🥈", "🥉"];

const TOGGLES = [
  { key: "all", label: "All", division: null, award: null },
  { key: "mc", label: "M Callahan", division: "M", award: "Callahan" },
  { key: "wc", label: "W Callahan", division: "W", award: "Callahan" },
  { key: "md", label: "M Donovan", division: "M", award: "Donovan" },
  { key: "wd", label: "W Donovan", division: "W", award: "Donovan" },
];

function Year2026({ db, allVideos, refreshVideos, onVote }) {
  const [activeToggle, setActiveToggle] = useState("all");
  const [leftVideo, setLeftVideo] = useState(null);
  const [rightVideo, setRightVideo] = useState(null);
  const [voting, setVoting] = useState(false);

  const filtered = React.useMemo(() => {
    const t = TOGGLES.find((x) => x.key === activeToggle);
    return allVideos
      .filter((v) => v.year === 2026)
      .filter((v) => (t.division ? v.division === t.division : true))
      .filter((v) => (t.award ? v.award === t.award : true));
  }, [allVideos, activeToggle]);

  const ranked = React.useMemo(
    () => [...filtered].sort((a, b) => (b.elo || 1000) - (a.elo || 1000)),
    [filtered]
  );

  const pickPair = useCallback(() => {
    const [l, r] = pickProximityPair(filtered);
    setLeftVideo(l);
    setRightVideo(r);
  }, [filtered]);

  useEffect(() => {
    pickPair();
  }, [pickPair]);

  const handleVote = async (winnerId, loserId) => {
    if (voting) return;
    setVoting(true);
    try {
      await updateEloRatings(winnerId, loserId, db);
      await refreshVideos();
      onVote && onVote();
    } catch (e) {
      console.error("Vote failed:", e);
    }
    setVoting(false);
  };

  return (
    <div className="year-page">
      <div className="year-toggles">
        {TOGGLES.map((t) => (
          <button
            key={t.key}
            className={`year-toggle${
              activeToggle === t.key ? " active" : ""
            }`}
            onClick={() => setActiveToggle(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {filtered.length < 2 ? (
        <div className="loading">
          Not enough 2026 videos yet for this category.
        </div>
      ) : (
        <div className="year-layout">
          <div className="year-vote">
            <div className="video-container">
              {leftVideo && rightVideo && (
                <>
                  <VideoBox
                    video={leftVideo}
                    handleVote={() => handleVote(leftVideo.id, rightVideo.id)}
                  />
                  <VideoBox
                    video={rightVideo}
                    handleVote={() => handleVote(rightVideo.id, leftVideo.id)}
                  />
                </>
              )}
            </div>
            <button className="vote-button" onClick={pickPair}>
              Skip
            </button>
          </div>

          <div className="year-rankings">
            <h3>2026 Rankings</h3>
            <div className="year-table-wrap">
              <table className="year-table">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Div</th>
                    <th>Video</th>
                    <th>School</th>
                  </tr>
                </thead>
                <tbody>
                  {ranked.map((v, i) => (
                    <tr key={v.id}>
                      <td>{MEDALS[i] || i + 1}</td>
                      <td>{v.division || "?"}</td>
                      <td>
                        <Link to={`/video/${v.id}`}>{v.name || "??"}</Link>{" "}
                        {v.winner ? (
                          <FaStar style={{ color: "gold", fontSize: 14 }} />
                        ) : v.finalist ? (
                          <FaRegStar style={{ color: "grey", fontSize: 12 }} />
                        ) : null}
                      </td>
                      <td>
                        <Link to={`/school/${encodeURIComponent(v.school || "")}`}>
                          {v.school}
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Year2026;
